import { useState } from "react";
import Modal from "../common/Modal";
import Button from "../common/Button";
import { exportExpenses } from "../../api/expenses";

// Download everything: a spreadsheet for you or your accountant, and the
// receipts as a zip, for one year or all time.

export default function ExportModal({ years, onClose }) {
  const [year, setYear] = useState("");
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");

  async function download(format) {
    setBusy(format);
    setError("");
    try {
      const blob = await exportExpenses(format, year);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `birdie-bus-${format === "zip" ? "receipts" : "expenses"}-${year || "all-time"}.${format === "zip" ? "zip" : "xlsx"}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 30000);
    } catch (e) {
      setError(
        String(e.message).includes("413")
          ? "That's more receipts than fit in one download. Pick a single year."
          : e.message || "Couldn't download it."
      );
    } finally {
      setBusy("");
    }
  }

  return (
    <Modal isOpen title="Export" onClose={onClose} maxWidthClass="max-w-md">
      {error && <div className="mb-3 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div>}
      <div className="space-y-4">
        <label className="block">
          <span className="block text-xs font-semibold text-birdie-charcoal/70 mb-1">Which period</span>
          <select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="w-full rounded-xl border border-birdie-green/20 bg-white px-3 py-2 text-sm"
          >
            <option value="">All time</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          {year && (
            <span className="block text-[11px] text-birdie-charcoal/45 mt-1">
              Expenses without a date only show up in “All time”.
            </span>
          )}
        </label>

        <ExportRow
          icon="📊"
          title="Spreadsheet (.xlsx)"
          sub="Opens in Excel or Google Sheets: expenses, money in, to-buy and a summary of who put in what."
          busy={busy === "xlsx"}
          disabled={Boolean(busy)}
          onClick={() => download("xlsx")}
        />
        <ExportRow
          icon="🗂️"
          title="Receipts (.zip)"
          sub="Every receipt photo and statement, named by date, vendor and amount, with an index."
          busy={busy === "zip"}
          disabled={Boolean(busy)}
          onClick={() => download("zip")}
        />
      </div>
    </Modal>
  );
}

function ExportRow({ icon, title, sub, busy, disabled, onClick }) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-birdie-green/15 p-3">
      <span className="text-2xl" aria-hidden>
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-birdie-charcoal">{title}</div>
        <div className="text-xs text-birdie-charcoal/55">{sub}</div>
      </div>
      <Button size="sm" onClick={onClick} disabled={disabled} className="shrink-0">
        {busy ? "Preparing…" : "Download"}
      </Button>
    </div>
  );
}
